import { FaPlus, FaMinus } from "react-icons/fa6";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";

const FAQs = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqItems = [
        {
            question: "What is MeetUsVR?",
            answers: [
                "MeetUsVR is a comprehensive platform for retail businesses, offering solutions to acquire and retain customers while digitalizing the shopping experience.",
                "Utilizing VR and conversational marketing, it bridges the gap between physical and digital retail.",
            ],
        },

        {
            question: "Is MeetUsVR safe to use?",
            answers: [
                "Yes, MeetUsVR is highly committed to safeguarding user data and privacy.",
                "We implement the highest security measures to protect your personal information and provide robust access controls.",
            ],
        },
        {
            question: "How do I start earning MVR Coins?",
            answers: [
                "You can start earning MVR Coins by spending time on the platform — chatting, playing games, or hosting virtual events.",
                "Additionally, reviewing products unlocks bonus rewards on top of your regular coin earnings.",
            ],
        },
        {
            question: "Can I transfer my coins to another wallet?",
            answers: [
                "Yes, MVR Coins are transferable to any compatible wallet. Simply use the transfer function within your dashboard.",
                "Make sure the receiving address is correct before confirming the transaction.",
            ],
        },
        {
            question: "Is there a limit to how many MVR Coins I can earn?",
            answers: [
                "There is no hard cap on earnings but rewards are subject to availability and your participation level.",
                "Keep an eye on our announcements for any changes to the reward structure.",
            ],
        },
    ];

    const toggleIndex = (index) => {
        setActiveIndex((prev) => (prev === index ? null : index));
    };

    return (
        <div className={styles.faqsSectionWrapper}>
            <MeetUsWrapper>
                <div className={styles.faqsSectionContent}>
                    <div
                        className={styles.faqsCard}
                        data-aos="fade-left"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <div className="">
                            <p className={styles.faqsTitle}>
                                Frequently Asked Questions{" "}
                            </p>
                        </div>
                        <div className={styles.faqsCards}>
                            {faqItems.map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`${styles.faqsCardItem} ${
                                        activeIndex === idx ? styles.open : ""
                                    }`}
                                >
                                    <div
                                        className={styles.flex}
                                        onClick={() => toggleIndex(idx)}
                                    >
                                        <h1 className={styles.title}>
                                            {item.question}
                                        </h1>
                                        <motion.span
                                            className={styles.icon}
                                            animate={{
                                                rotate:
                                                    activeIndex === idx
                                                        ? 180
                                                        : 0,
                                            }}
                                            transition={{ duration: 0.3 }}
                                        >
                                            {activeIndex === idx ? (
                                                <FaMinus />
                                            ) : (
                                                <FaPlus />
                                            )}
                                        </motion.span>
                                    </div>
                                    <AnimatePresence initial={false}>
                                        {activeIndex === idx && (
                                            <motion.div
                                                key="content"
                                                initial="collapsed"
                                                animate="open"
                                                exit="collapsed"
                                                variants={{
                                                    open: {
                                                        opacity: 1,
                                                        height: "auto",
                                                    },
                                                    collapsed: {
                                                        opacity: 0,
                                                        height: 0,
                                                    },
                                                }}
                                                transition={{
                                                    duration: 0.4,
                                                    ease: [
                                                        0.04, 0.62, 0.23, 0.98,
                                                    ],
                                                }}
                                            >
                                                <div className={styles.answer}>
                                                    {item.answers.map(
                                                        (ans, i) => (
                                                            <p
                                                                key={i}
                                                                className={
                                                                    styles.description
                                                                }
                                                            >
                                                                {ans}
                                                            </p>
                                                        ),
                                                    )}
                                                </div>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default FAQs;
